import { render, staticRenderFns } from "./BatchListView.vue?vue&type=template&id=3a285bfb"
import script from "./BatchListView.vue?vue&type=script&lang=js"
export * from "./BatchListView.vue?vue&type=script&lang=js"
import style0 from "./BatchListView.vue?vue&type=style&index=0&id=3a285bfb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports